// extracted by mini-css-extract-plugin
export default {"siderContainer":"information-sidebar-desktop_siderContainer__95pyH","informationContainer":"information-sidebar-desktop_informationContainer__79WNu"};